/** field name: input file */
export const FIELD_KEY_NAME_FILE = 'file';
/** field name: uniqueId */
export const FIELD_KEY_NAME_UNIQUE_ID = 'uniqueId';
/** field name: exntension */
export const FIELD_KEY_NAME_EXTENSION = 'extension';
